export default __webpack_public_path__ + "static/media/AdminLTELogo2.f39d04d0.jpg";